import { type RouteDefinition } from "../../shared/types/routes";
import Home from "./Home";

export const homeRoutes: RouteDefinition[] = [
  {
    path: "/",
    element: <Home />,
  },
];
